import { render, staticRenderFns } from "./ExternalTaskUpdated.vue?vue&type=template&id=67424bc1&"
import script from "./ExternalTaskUpdated.vue?vue&type=script&lang=js&"
export * from "./ExternalTaskUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports